import { LinkButton } from '@cian/ui-kit/button';
import { IconPhone16 } from '@cian/ui-kit/icons';
import * as React from 'react';

export interface IPhoneButtonProps {
  phone?: string | null;
  text?: string;
  onClick?(): void;
}

export const PhoneButton: React.FC<IPhoneButtonProps> = ({ text = 'Позвонить', phone, onClick }) => {
  if (!phone) {
    return null;
  }

  return (
    <LinkButton fullWidth href={`tel:+${phone}`} beforeIcon={<IconPhone16 color="white_100" />} onClick={onClick}>
      {text}
    </LinkButton>
  );
};
